import { useFetchData, useGenericMutation } from "hooks/useAxios";
import { Student } from "types/types";

export const useGetStudent = ({ studentId }: { studentId?: number }) =>
  useFetchData<Student>({
    endpoint: `v1/students/${studentId}`,
    queryKey: ["student", studentId ?? ""],
    enabled: !!studentId,
  });

export const useUpdateMemo = () => {
  return useGenericMutation<{
    id: number;
    memo: string;
  }>({
    method: "put",
    endpoint: ({ id }) => `v1/students/${id}/memo`,
    invalidateQueries: (_, { id }) => [["student", id]],
    showLoading: false,
  });
};
